<template>
	<div class="home-box">
		<div class="header_box">
			<goBack :page_title="page_title" :SuperiorName="SuperiorName"></goBack>
			<div class="more_box">
				<div class="more_relative">
					<div class="change_more" @click.stop="change_more()">
						<i class="el-icon-more-outline"></i>
					</div>
					<div class="choice_box" v-if="show_choice_box" :class="show_choice_box ? 'show_choice_box' : 'hidde_choice_box'">
						<div class="choice_list">
							<div class="choice_item" v-for="(c_item, c_index) in choice_list" :key="c_index" @click.stop="post_operation(c_item, c_item)">{{ c_item.name }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 个人信息 -->
		<UserHeaderInformation :Information_user_id="Information_user_id" :parent_type="activeMenu"  @operations="operations"></UserHeaderInformation>
	 
		<!-- 顶部菜单 -->
		<div class="menu-bar">
			<button v-for="menu in menus" :key="menu.key" :class="{ active: activeMenu === menu.key }" @click="setActiveMenu(menu)">
				<h2 class="button_text">{{ menu.name }}</h2>
			</button>
		</div>
	 
		<!-- <PostingModule></PostingModule> -->

		<!-- 内容显示 -->
		<div class="content-box">
			<div v-if="activeMenu === 'Posts'" class="Posts-content">
				<PostList ref="PostListRef" :Post_List="Posts_list" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" @operations="operations"></PostList>
				<Pagination class="postPagination" v-show="total_num_Posts > 0" :per_page.sync="page_Posts.per_page" :page-sizes="pageSizes" :page.sync="page_Posts.page" :total="total_num_Posts" @pagination="get_page_Data_Posts" ></Pagination>
			</div>
			<div v-if="activeMenu === 'Media'" class="Media-content">
				<PostList :Post_List="Media_list" :Loading="Loading" :parent_type="activeMenu" :page_name="page_name" @operations="operations"></PostList>
				<Pagination class="postPagination" v-show="total_num_Media > 0" :per_page.sync="page_Media.per_page" :page-sizes="pageSizes" :page.sync="page_Media.page" :total="total_num_Media" @pagination="get_page_Data_Media" ></Pagination>
			</div>
		</div>
	</div>
</template>

<script>
import UserHeaderInformation from '../components/public/UserHeaderInformation.vue'
import PostingModule from '../components/public/PostingModule.vue'
import PostList from '../components/public/PostList.vue'
import Pagination from "@/components/Pagination"
import { post_community_userposts, post_community_dislikeuser } from '@/api/community.js'

export default {
components: { PostingModule, PostList, UserHeaderInformation, Pagination },
  name: "users",
  
  data() {
		return {
			page_title: "",
			SuperiorName: "",
			menus: [
				{ key: "Posts", name: this.$t('PersonalArr.Posts'), post_type: 1, first: true },
				{ key: "Media", name: this.$t('PersonalArr.Media'), post_type: 2, first: true },
			],
			activeMenu: "", // 默认选中菜单 Posts
			currentMenu: "",
			page_name: "users",
			Posts_list: [],
			Media_list: [],
			following_list: [],
			Information_user_id: this.$route.params.user_id,
			search: {
				user_id: this.$route.params.user_id,
				post_type: 1, //1图文, 2视频
			},
			page_Posts: {
				page: 1,
				per_page: 10,
			},
			page_Media: {
				page: 1,
				per_page: 10,
			},
			Loading: false,
			total_num_Posts: 0,
			total_num_Media: 0,
			last_page_Posts: 0,
			last_page_Media: 0,
			pageSizes: [10, 20, 30],
			show_choice_box: false,
			choice_list:[
				{
					id: 2,
					type: "dislikeuser",
					name: this.$t('postsArr.Don_t_like_the_author'),
					remarks: "不喜欢作者",
				},
				// {
				// 	id: 4,
				// 	type: "cancel_operation",
				// 	name: this.$t('postsArr.Cancel'),
				// 	remarks: "取消",
				// }
			],
		};
	},
  
  
  // 监听
  watch: {
  	"search.user_id": {
  		handler: function (newValue, oldValue) {
			this.set_type_list()
  		},
  	},
  },
	// 路由进入可操作数据
	beforeRouteEnter(to, from, next) {
		next()
	},
	
	beforeRouteUpdate(to, from, next) {
		// 当路由更新时，更新 userId 数据
		console.log(to.params.parent_type)
		if(to.params.user_id){
			this.Information_user_id = to.params.user_id;
			this.search.user_id = to.params.user_id;
		}
		console.log("当路由更新时，更新 userId 数据")
		next();
	},
  
	// 路由进入可操作数据
	activated() {
		console.log('路由进来其他用户页面成功返回');
	
		// 当路由更新时，更新 userId 数据
		if(this.$route.params.user_id){
			this.Information_user_id = this.$route.params.user_id;
			this.search.user_id = this.$route.params.user_id;
		}
		this.SuperiorName = this.$route.params.parent_type ? this.$route.params.parent_type : "",
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
	},
	
	// beforeCreate() {
  	
	// }
  
	created () {
		
	},
    
	mounted() {
		this.setActiveMenu(this.currentMenu ? this.currentMenu : this.menus[0])
		this.SuperiorName = this.$route.params.parent_type ? this.$route.params.parent_type : "",
		// this.set_type_list()
		this.get_addEventListener()
	},
    
	methods: {
		
		// 更新激活的菜单
		setActiveMenu(menu, click) {
			if(this.activeMenu == menu.key && click == 'click'){ return }
			this.currentMenu = menu
			this.activeMenu = menu.key
			this.search.post_type = menu.post_type
			this.set_type_list(!menu.first ? 'HiddeLoading' : '')
			return menu.first = false
		},
		
		// 根据类型获取数据
		set_type_list(typeName){
			if(this.search.post_type == 1){
				this.get_data_list(this.page_Posts, typeName)
			}else{
				this.get_data_list(this.page_Media, typeName)
			}
		},
		
		// 获取分页 Posts
		get_page_Data_Posts(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.page_Posts.page = obj.page
			}
			if(obj && obj.per_page){
				this.page_Posts.per_page = obj.per_page
			}
			this.get_data_list(this.page_Posts)
		},
		
		// 获取分页 Media
		get_page_Data_Media(obj) {
			console.log(obj)
			if(obj && obj.page){
				this.page_Media.page = obj.page
			}
			if(obj && obj.per_page){
				this.page_Media.per_page = obj.per_page
			}
			this.get_data_list(this.page_Media)
		},
		
		//获取列表
		get_data_list(pageObj, typeName){
			console.log(pageObj)
			if(!this.$store.state.userinfo.user_id){ return }
			if(this.Loading){ return }
			if(typeName != "HiddeLoading"){
				this.Loading = true
			}
			let obj = {
				user_id: this.search.user_id, 
				post_type: this.search.post_type, 
				page: pageObj.page,
				per_page: pageObj.per_page
			}
			console.log(obj)
			post_community_userposts(obj)
		   .then((res) => {
				console.log(res)
				this.Loading = false
				if(res.code == 0){
					this.data_processing(res)
				}else{
					this.exception_handling(res, "userposts")
				}
				let path = this.$router.currentRoute.path
				this.$setTags.updateCanonical(`${path}?type=${obj.post_type}&page=${obj.page || 1}`)
				// this.$setTags.updateCanonical(`/users/${obj.user_id}?type=${obj.post_type}&page=${obj.page || 1}`)
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "userposts")
		   })
		},
		
		//数据处理
		data_processing(res){
			if(res && res.data){
				if(res.data.data){
					if(this.search.post_type == 1){
						this.Posts_list = res.data.data
						this.total_num_Posts = res.data.total ? res.data.total : 0
						this.last_page_Posts = res.data.last_page ? res.data.last_page : 0
						this.callGrandChildFun()
					}else{
						this.Media_list = res.data.data
						this.total_num_Media = res.data.total ? res.data.total : 0
						this.last_page__Media = res.data.last_page ? res.data.last_page : 0
					}
				}else{
					if(this.search.post_type == 1){
						this.Posts_list = []
						this.total_num_Posts = 0
						this.last_page_Posts = 0
					}else{
						this.Media_list = []
						this.total_num_Media = 0
						this.last_page_Posts = 0
					}
				}
			}
		},
		
		//异常处理
		exception_handling(err, type){
			this.Loading = false
			if(type == ""){
				this.list = []
			}
			this.$errorMessage(err)
			// this.$message('err.data.message', 'error')
		},
		
		//除了change_more按钮之外的点击事件都把show_choice_box收起
		get_addEventListener(){
			document.addEventListener('click', (e) => {
				const isMoreElement = e.target.closest('.change_more');
				if (!isMoreElement) {
				  this.show_choice_box = '';
				}
			});
		},
		
		//点击更多操作
		change_more(){
			// console.log(item)
		   this.show_choice_box = !this.show_choice_box;
			// this.show_choice_box = true
		},
		
		//更多操作执行
		post_operation(item, Operation){
			console.log(item)
			console.log(Operation)
			if(Operation.type == "dislikeuser"){
				this.post_community_dislikeuser(item) //不喜欢作者
			}
			
			if(Operation.type == "cancel_operation"){
				this.show_choice_box = false
			}else{
				let that = this
				setTimeout(()=>{
					that.show_choice_box = false
				}, 200)
			}
		},
		
		//不喜欢该用户/作者
		post_community_dislikeuser(){
			post_community_dislikeuser({ user_id: this.$route.params.user_id })
		   .then((res) => {
				console.log(res)
				if(res.code == 0){
					this.$message('Feedback success', 'success')
				}else{
					this.exception_handling(res, "dislikeuser")
				}
		   })
		   .catch((err) => {
				console.log(err)
				this.exception_handling(err, "dislikeuser")
		   })
		},
		
		//子组件关注操作 取消/关注/删除
		operations(type){
			if(type == 'success'){
				// 操作成功刷新列表数据
				this.set_type_list('HiddeLoading')
			}
		},
	
		// 调用孙子组件的方法
		callGrandChildFun() {
			// 获取子组件的实例
			const PostListRef = this.$refs.PostListRef;
			if (PostListRef && PostListRef.$children && PostListRef.$children.length !== 0) {
				let children = PostListRef.$children;
				
				children.forEach(item => {
					if (item.set_bg_color) { // 确保方法存在
						item.set_bg_color('again');
					} else {
						console.warn("子组件没有 set_bg_color 方法:", item);
					}
				});
			} else {
				console.error("未找到 PostListRef 的 ref 或 $children 为空");
			}
		},
	},
  
};
</script>

<style lang="less" scoped>
	*{
		box-sizing: border-box;
	}
	.Content-layout{
		background-color: transparent !important;
	}
	.home-box {
	  width: 100%;
	  max-width: 1280px;
	  margin: 0 auto;
	  background-color: transparent;
	}
	
	.header_box{
		padding: 10px 8px;
		margin-bottom: 10px;
		border-radius: 8px;
		background-color: #ffffff;
		position: relative;
		
		.more_box{
			position: absolute;
			top: 0;
			right: 0;
			height: 35px;
		   display: flex;
		   align-items: center;
		   justify-content: center;
		   width: 35px;
			margin-right: 5px;
			margin-top: 10px;
		}
		.more_relative{
			height: 100%;
			display: flex;
			align-items: center;
			cursor: pointer;
			position: relative;
		}
		.margin_left{
			margin-left: 12px;
		}
		.choice_box{
			width: 200px;
			display: flex;
			flex-direction: column;
			position: absolute;
			right: 0;
			top: 0;
			margin-top: 30px;
			background-color: #f5f5f5;
			box-shadow: 0.5px 0.5px 0  0.5 #000000;
			padding: 5px 0px;
			z-index: 99;
			border-radius: 8px;
		}
		.choice_item{
			padding: 5px 10px;
			font-size: 14px;
			list-style: 1;
			&:hover{
				background-color: aliceblue;
			}
		}
	}
	.menu-bar {
		margin-top: 10px;
	   display: flex;
	   justify-content: space-between;
	}

	.menu-bar button {
		border: none;
		font-size: 16px;
		cursor: pointer;
		color: #1E1E1E;
		font-weight: 600;
		width: calc(calc(100% - 10px) / 2);
		border-radius: 8px;
		background-color: #ffffff;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 0px 10px;
	}
	.button_text{
		padding: 10px 0px;
		height: 100%;
		flex:  0 0 auto;
		font-size: 16px;
		border-bottom: 2px solid #ffffff;
	}

	.menu-bar button.active .button_text {
	  border-bottom: 2px solid #000000;
	}

	.content-box {
	  margin-top: 10px;
	}

	.Posts-content,
	.Media-content {
	  background-color: #f9f9f9;
	  border-radius: 8px;
	}
</style>
